import React, { FC, forwardRef } from 'react';
import cn from 'classnames';

import CLASSNAMES from './responsiveClassnames';
import { TextProps } from './TextTypes';

const Text: FC<TextProps> = forwardRef(
  (
    {
      children,
      type = 'body3',
      htmlType,
      as: Tag = 'span',
      responsive = 'sm',
      color = 'base-main',
      className = '',
      style = {},
      truncate = false,
      ...other
    },
    ref,
  ) => (
    <Tag
      className={cn(
        {
          truncate,
        },
        CLASSNAMES[type] ? CLASSNAMES[type](responsive === 'md') : '',
        `text-${color}`,
        className,
      )}
      ref={ref}
      type={htmlType}
      style={style}
      {...other}
    >
      {children}
    </Tag>
  ),
);

export default Text;
